import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Ogni settimana ricominci tutto da capo',
  lines: ['Preparare programmi. Creare nuove sessioni. Organizzare intervalli. Pianificare i lunghi. Calcolare i volumi. Distribuire le intensità. Adattare il lavoro ai diversi livelli.', 'E prima ancora di iniziare il primo allenamento... Hai già trascorso ore davanti al computer.']
}, {
  emoji: '🤔',
  title: 'Ogni atleta ha obiettivi completamente diversi',
  lines: ['Alcuni preparano una 5K. Altri una 10K. Altri una Mezza Maratona. Altri una Maratona. Alcuni vogliono migliorare il tempo. Altri semplicemente correre senza infortuni.', 'Ogni atleta richiede modifiche, adattamenti e una programmazione specifica. Creare tutto manualmente richiede tantissimo tempo.']
}, {
  emoji: '📚',
  title: 'Hai tantissimo materiale... ma niente è davvero organizzato',
  lines: ['Libri. PDF. Video. Corsi. Appunti. Fogli Excel. Negli anni hai accumulato moltissime informazioni.', 'Ma ogni volta devi cercare, confrontare, modificare e ricostruire tutto. Ti manca un unico sistema professionale già pronto.']
}, {
  emoji: '😩',
  title: 'Passi più tempo a preparare gli allenamenti che ad allenare',
  lines: ['Tra pianificazioni... Programmi... Valutazioni... Aggiornamenti... Monitoraggio... Documentazione... Preparazione delle gare...', 'Dedichi sempre più tempo al lavoro dietro lo schermo che ai tuoi atleti.']
}];
export function PainSection() {
  return <section className="py-6 px-4 sm:px-6 bg-cream" data-id="element-100" data-mp="3imceglr0gls6">
      <h2 className="text-lg sm:text-3xl font-heading font-extrabold text-center text-navy mb-2 leading-tight uppercase" data-id="element-101" data-mp="3in4atysfmnji">
        Ti Ritrovi in Una di Queste Situazioni?
      </h2>

      <p className="text-[13px] sm:text-base text-anthracite text-center mb-4 max-w-2xl mx-auto leading-snug" data-id="element-102" data-mp="2q59wvlgb4013">
        Ami allenare i tuoi runner e aiutarli a raggiungere nuovi obiettivi. Ma
        preparare programmi completi richiede sempre più tempo.{' '}
        <span className="font-semibold text-navy" data-id="element-103" data-mp="u2wzhc75b9f8">
          Se lavori come Running Coach, Personal Trainer, preparatore atletico o
          segui gruppi di corsa, probabilmente conosci molto bene queste
          situazioni.
        </span>
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 max-w-4xl mx-auto" data-id="element-104" data-mp="12txau23d62os">
        {pains.map(pain => <div key={pain.title} className="bg-white p-3.5 rounded-lg border-l-4 border-gold shadow-sm" data-id="element-105" data-mp="66slxwyekkyk">
            <h3 className="text-[13px] sm:text-base font-heading font-bold text-navy mb-1 leading-snug" data-id="element-106" data-mp="f5w6z6h4rafp">
              <span aria-hidden="true" data-id="element-107" data-mp="k4h4uz8wti0z">{pain.emoji}</span> {pain.title}
            </h3>
            {pain.lines.map((line, j) => <p key={j} className="text-anthracite text-[12.5px] sm:text-sm leading-relaxed mb-1 last:mb-0" data-id="element-108" data-mp="1qjzxu3sf8igj" data-mpi={j}>
                {line}
              </p>)}
          </div>)}
      </div>
    </section>;
}